<template>
    <div class="collection-wrap">
        <div class="ir grid">     
			<div class="ir column stretch nav" id="izbirka-nav">
				<i-zbirka-add></i-zbirka-add>                       
			</div>                
			<div class="ir column filter-wrap" v-if="isEmpty === false">
				<div class="filter ui top icon labeled button" v-on:click="filter()">
					<i class="filter icon"></i>
					<div><span class="text">Prikaz gradiv</span></div>
				</div>
				<br>
				<span class="hidden-notice" v-if="displayFilter === false && toggleSubjects.indexOf(false) !== -1">iZbirka vsebuje skrita gradiva.</span>
			</div>
        </div>

        <div class="ui message" v-if="displayFilter">
			<div class="ui grid">
				<div class="row ui form filter-settings" >
	                <div class="seven wide column show-materials">
	                    <div class="field">Prikaži gradiva:</div>
	                    <div v-for="(label, key) in labels" v-if="label.subject!=='zz'">
	                        <div class="ui checkbox">
	                            <input type="checkbox" v-model="toggleSubjects[key]" :id="`subject-${key}`"/>
	                            <label :for="`subject-${key}`">{{label.subject}}</label>
	                        </div>
	                    </div>
	                </div>
	                <div class="seven wide column">
	                    <div class="field">Uredi po abecedi:</div>
	                    <div class="ui radio checkbox">
	                        <input value="po-predmetih" type="radio" name="group1" v-model="picked" id="sortBySubject">
	                        <label class="radio-content" for="sortBySubject">po predmetih</label>
	                    </div>
	                    <div class="ui radio checkbox">
	                        <input value="po-naslovu" type="radio" name="group1" v-model="picked" id="sortByAlphabet">
	                        <label class="radio-content" for="sortByAlphabet">po naslovu gradiva</label>
	                    </div>
	                </div>
	                <div class="right floated right aligned column">
	                    <div class="ui right floated close" v-on:click="filter('close')">
	                    <i class="close icon"></i>
	                    </div>
	                </div>
	            </div>
	            <div class="row no-match" v-if="toggleSubjects.length > 0 && toggleSubjects.indexOf(true) === -1">
	                <div class="column">
	                    <p>Kriterijem ne ustreza nobeno gradivo.</p>
	                </div>
	            </div>
			</div>
		</div>

    	<div class="ui grid stretch">
    		<div class="row" v-if="promos">
    			<div class="column">
    				<div class="ui yellow message promo" v-for="promo in promos" v-on:click="openPromo(promo, $event)">
    					<i class="info circle icon"></i>
    					<i class="close icon" v-on:click.stop="dismissPromo(promo, $event)"></i>
    					V iZbirko je možno dodati gradivo <strong>{{promo.title}}</strong> ({{promo.course}}).
    				</div>
    			</div>
    		</div>           
            

    		<div class="doubling row" v-bind:class="[mainClass]">
    			<div class="ui loader active" v-if="!loaded"></div>
    			<div class="stretch column empty-wrap" v-if="isEmpty">
    				<svg version="1.1" id="empty-rect" ref="empty-rect" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="100%" height="100%" xml:space="preserve"></svg>
    				<div class="empty-text"><span>iZbirka je prazna.</span></div>
    			</div>
    			<template v-else-if="isEmpty === false">
    				<div v-for="(credit, index) in credits" class="column" v-if="credit.show">
    					<div class="book-wrap">
    						<a :href="`https://folio.rokus-klett.si/?credit=${credit.creditId}`" class="book block" ref="items" v-on:click="openContent($event, credit)">
    		
    							<div class="cover-wrap">
    								<img alt="Naslovnica" :src="imageSrc(credit.creditId)"/>
    							</div>
    		
    							<div class="title">
    								{{credit.title}}
    							</div>
    		
    							<div class="desc">
    								{{credit.description}} <span v-if="credit.hasEnriched" class="enriched">(obogatena različica)</span>
    							</div>
    		                    
    							<div class="footer hidden">
    								<div class="icons-wrap" v-if="false">
    									<!-- <% if(gradivo.getVideo()){ %> -->
    									<i class="icon video"></i>
    									<!-- <%} %> -->
    									<!-- <% if(gradivo.getAudio()){ %> -->
    									<i class="icon audio"></i>
    									<!-- <%} %> -->
    									<!-- <% if(gradivo.getLinks()){ %> -->
    									<i class="icon links"></i>
    									<!-- <%} %> -->
    									<!-- <% if(gradivo.getNotes()){ %> -->
    									<i class="icon notes"></i>
    									<!-- <%} %> -->
    									<!-- <% if(gradivo.getInteractive()){ %> -->
    									<i class="icon interactive"></i>
    									<!-- <%} %> -->
    								</div>
    								<i class="icon trash d-none" v-on:click.stop="startRemove(credit, index)" v-if="isDeletable(credit)"></i>
    							</div>
    							<div class="ui dimmer delete-confirm">
    								<div class="content">
    									<div class="center" v-if="showDimmer(credit) == 'master'">
    										<h4>Ali ste prepričani, da želite odstraniti to gradivo?</h4>
    										<button class="ui yellow yes button" v-on:click.stop="confirmRemove(credit, index)">Da</button>
    										<button class="ui yellow no button" v-on:click.stop="abortRemove(credit, index)">Ne</button>
    									</div>
    									<div class="center" v-if="showDimmer(credit) == 'slave'">
    										<img src="/images/delete-link.svg">
    									</div>
    									<div class="center" v-if="showDimmer(credit) == 'master-spin'">
    										<div class="ui loader"></div>
    									</div>
    								</div>
    							</div>
    						</a>
    					</div>
    				</div>
    			</template>
    		</div>
    	</div>
    </div>
</template>

<script>
	import Snap from 'snapsvg';
	import queryString from 'query-string'
	import hasAccess from '../modals/HasAccess.vue'

    export default {
    	data() {
    		return {
    			credits: null,
    			deletingItem: null,
				removing: false,
				promos: null,
                // filters
                displayFilter: false,
                labels: [],
                picked: 'po-naslovu',
                toggleSubjects: []
    		}
    	},
    	mounted() {
			this.loadCredits();
        },
        methods: {
        	loadCredits() {
        		axios.get(this.route('izbirka')).then((response) => {
	            	this.credits = response.data.sort(this.creditsCompare);
	            	this.deletingItem = null;
					this.removing = false;
					
					this.loadPromo();
                    this.setLabels(response);
                    this.setCheckboxes();
                    this.setRadio();
                    this.toggleSubjectsDisplay();
					this.toggleAlphabetType();
	            });
			},
            setLabels(response){
                for (let i = 0; i < response.data.length; i++) {
                    if (response.data[i].courses.length !== 0) {
                        response.data[i].label = response.data[i].courses[0].course;
                        this.labels.push(response.data[i].courses[0].course);
                        this.credits[i].show = true;
                    }
                    else {
                        response.data[i].label = 'zz';
                        this.labels.push('zz');
                        this.credits[i].show = true;
                    }
                }
                this.labels = [...new Set(this.labels)].sort();
                for (let k = 0; k < this.labels.length; k++) {
                    this.labels[k] = {'subject': this.labels[k], 'value': true};
                }
            },
            setCheckboxes() {
                let getSubjects;
                if (localStorage.getItem('selected-subjects') !== null) {
                    getSubjects = localStorage.getItem('selected-subjects').split(',');
                } else {
                    getSubjects = 'no local storage';
                }
                localStorage.removeItem('selected-subjects')
                for (let i = 0; i < this.labels.length; i++) {
                    if (getSubjects[i] === 'true') {
                        this.toggleSubjects[i] = true;
                    } else if (getSubjects[i] === 'false') {
                        this.toggleSubjects[i] = false;
                    } else {
                        this.toggleSubjects[i] = true;
                    }                    
                }
            },
            setRadio() {
                if (localStorage.getItem('selected-radio') !== null) {
                    this.picked = localStorage.getItem('selected-radio');
                }
            },
			loadPromo() {
				axios.get(this.route('promo')).then(response => {
					this.promos = response.data;
				});
			},
			dismissPromo(promo, event) {
				axios.post(this.route('promo'), {
						id: promo.id
					}).then(response => {
					this.promos = this.promos.filter(function(item) { 
						return item !== promo;
					});
					if (this.promos.length == 0) this.promos = null;
				});
			},
			openPromo(promo, $event) {
				let query = queryString.stringify({
					filter: promo.creditId
				});
				window.location.href = this.route('brezplacna-gradiva') + '?' + query;
			},
            creditsCompare(a, b) {
                if (a.title != b.title) {
                    return a.title.localeCompare(b.title);
                } else {
                    return a.description.localeCompare(b.description);
                }
                this.$forceUpdate();
            },
            subjectCompare(a, b) {
                if (a.label != b.label) {
                    return a.label.localeCompare(b.label);
                } else {
                    return a.title.localeCompare(b.title);
                }
                this.$forceUpdate();
            },
        	onResize() {
        		this.createEmptyBorder();
        	},
        	createEmptyBorder() {
        		var paper =  Snap(this.$refs['empty-rect']),
					parent = $(this.$refs['empty-rect']).closest(".column");
                paper.selectAll("rect").remove();
				paper.rect(1, 1, parent.width() - 2, parent.height() - 2, 20, 20).attr({
					preserveAspectRatio: "none"
				});
        	},
        	imageSrc(credit) {
        		return 'images/covers/' + credit + '.jpg';
        	},
        	startRemove(credit, index) {
        		this.deletingItem = credit;
        	},
        	confirmRemove(credit, index) {
        		let product = credit.parent ? credit.parent : credit.creditId;
        		this.removing = true;
        		axios.delete(this.route('izbirka'), {
        			params: { product }
        		}).then(response => {
        			if (response.status == 204) {
        				this.loadCredits();
        			} else {
        				console.error('Error removing product', credit);
        			}
        		});
        	},
        	abortRemove(credit, index) {
        		this.deletingItem = null;
        	},
        	openContent(event, credit, confirm) {
				event.preventDefault();
				if (credit.withinTimeRestriction && !confirm) {
					this.$root.$emit('add-popup', hasAccess, {
						withinTimeRestriction: credit.withinTimeRestriction,
						hasAccess: credit.hasAccess,
						credit: credit,
						callback: this.openContent.bind(this, event)
					});
				} else {
					const izbrikaDataLayer = window.user ? ({'event': "izbrika-view-item", 'userID': window.user, "izbirka-view-item": credit.creditId}) : undefined;
					izbrikaDataLayer && window._mtm && window._mtm.push(izbrikaDataLayer);
					window.open(this.route('vsebine', credit.creditId), '_blank');
				}
        	},
        	isDeletable(credit) {
        		return credit.app.length == 1 && credit.app[0] == 'iRokus';
        	},
        	showDimmer(credit) {
        		if (this.deletingItem == null) {
        			if (this.$refs['items']) {
        				for (let index = 0; index < this.$refs['items'].length; index++) {
	        				let el = this.$refs['items'][index];
	        				$(el).find('.delete-confirm').dimmer('hide');
	        			}
        			}
        			return null;
        		}
        		if (this.deletingItem == credit) {
        			let index = this.credits.indexOf(credit);
        			let el = this.$refs['items'][index];
        			$(el).find('.delete-confirm').dimmer('show');
        			return this.removing ? 'master-spin' : 'master';
        		}
        		if (this.deletingItem.parent && credit.parent && credit.parent == this.deletingItem.parent) {
        			let index = this.credits.indexOf(credit);
        			let el = this.$refs['items'][index];
        			$(el).find('.delete-confirm').dimmer('show');
        			return 'slave';
        		}
        	},
            filter(state) {
                this.displayFilter = !this.displayFilter;
                if (state === 'close') {
                    this.displayFilter = false;
                }
            },
            toggleSubjectsDisplay() {
                for (let i = 0; i < this.toggleSubjects.length; i++) {
                    for (let j = 0; j < this.credits.length; j++) {
                        if (this.toggleSubjects[i] == true && this.labels[i].subject === this.credits[j].label) {
                            this.credits[j].show = true;
                        }
                        else if (this.toggleSubjects[i] == false && this.labels[i].subject === this.credits[j].label) {
                            this.credits[j].show = false;
                        }
                    }
                }
                localStorage.setItem('selected-subjects', this.toggleSubjects);
            },
            toggleAlphabetType(a, b) {
                if (this.picked === 'po-naslovu') {
                    this.credits.sort(this.creditsCompare);
                    
                } else if (this.picked === 'po-predmetih') {
                    this.credits.sort(this.subjectCompare);
                }
                localStorage.setItem('selected-radio', this.picked);           
			}
        },
        beforeDestroy() {
        	window.removeEventListener('resize', this.onResize);
        },
        watch: {
        	isEmpty() {
        		if (this.isEmpty) {
        			this.$nextTick(() => {
        				this.createEmptyBorder();
        				window.addEventListener('resize', this.onResize);
        			});
        		} else {
        			window.removeEventListener('resize', this.onResize);
        		}
        	},
            toggleSubjects() {
                this.toggleSubjectsDisplay()      
            },
            picked() {
                this.toggleAlphabetType();
            }
        },
        computed: {
        	loaded() {
        		return this.credits != null;
        	},
        	isEmpty() {
        		return this.credits && this.credits.length == 0;
        	},
        	mainClass() {
        		return this.isEmpty ? 'one column' : 'four column';
        	}
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/IZbirka.vue